export interface AnnualEIT105080List {
    row?: string,
    name?: string,
    originalValue?: string,
    indent?: number,
    colspan?: number,
    isEdit?: boolean,
    isEdit2?: boolean,
    isEdit3?: boolean,
    isEdit4?: boolean,
    isEdit5?: boolean,
    type?: string,
    thisYearDepreciate?: string,
    accountRecordTotalDepreciate?: string,
    assetsTaxBase?: string,
    taxDepreciate?: string,
    provisionCalculateDepreciate?: string,
    accelerateDepreciateStatistics?: string,
    taxTotalDepreciate?: string,
    taxAdjustmentAmount?: string,
    iscol?: boolean,
    row2?: boolean,

}

let list: AnnualEIT105080List[] = [
    {
        name: "一、固定资产（2+3+4+5+6+7）",
        row: "1",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "（一）房屋、建筑物",
        row: "2",
        type: "所有固定资产",
        colspan: 6,
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        iscol: true,

    },
    {
        name: "（二）飞机、火车、轮船、机器、机械和其他生产设备",
        row: "3",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        iscol: true,
    },
    {
        name: "（三）与生产经营活动有关的器具、工具、家具等",
        row: "4",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        iscol: true,

    },
    {
        name: "（四）飞机、火车、轮船以外的运输工具",
        row: "5",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        iscol: true,

    },
    {
        name: "（五）电子设备",
        row: "6",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        iscol: true,

    },
    {
        name: "（六）其他",
        row: "7",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        iscol: true,

    },
    {
        name: "（一）重要行业固定资产加速折旧（不含一次性扣除）",
        row: "8",
        type: "其中：享受固定资产加速折旧及一次性扣除政策的资产加速折旧额大于一般折旧额的部分",
        colspan: 7,
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: false,
        isEdit2: true,
        isEdit3: true,
        iscol: true,

    },
    {
        name: "（二）其他行业研发设备加速折旧",
        row: "9",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: false,
        isEdit2: true,
        isEdit3: true,
        iscol: true,

    },
    {
        name: "（三）固定资产一次性扣除",
        row: "10",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: false,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        iscol: true,

    },
    {
        name: "（四）技术进步、更新换代固定资产",
        row: "11",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: false,
        isEdit2: true,
        isEdit3: true,
        iscol: true,

    },
    {
        name: "（五）常年强震动、高腐蚀固定资产",
        row: "12",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: false,
        isEdit2: true,
        isEdit3: true,
        iscol: true,

    },
    {
        name: "（六）外购软件折旧",
        row: "13",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: false,
        isEdit2: true,
        isEdit3: true,
        iscol: true,

    }, {
        name: "（七）集成电路企业生产设备",
        row: "14",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: false,
        isEdit2: true,
        isEdit3: true,
        iscol: true,

    },
    {
        name: "二、生产性生物资产（16+17）",
        row: "15",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        isEdit5: true,

    },
    {
        name: "（一）林木类",
        row: "16",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "（二）畜类",
        row: "17",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "三、无形资产（19+20+21+22+23+24+25+27）",
        row: "18",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "（一）专利权",
        row: "19",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "（二）商标权",
        row: "20",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "（三）著作权",
        row: "21",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "（四）土地使用权",
        row: "22",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "（五）非专利技术",
        row: "23",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "（六）特许权使用费",
        row: "24",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "（七）软件",
        row: "25",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "其中：享受企业外购软件加速摊销政策",
        row: "26",
        originalValue: "",
        indent: 2,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: false,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "（八）其他",
        row: "27",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "四、长期待摊费用（29+30+31+32+33）",
        row: "28",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "（一）已足额提取折旧的固定资产的改建支出",
        row: "29",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "（二）租入固定资产的改建支出",
        row: "30",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "（三）固定资产的大修理支出",
        row: "31",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "（四）开办费",
        row: "32",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "（五）其他",
        row: "33",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "五、油气勘探投资",
        row: "34",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "六、油气开发投资",
        row: "35",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "合计（1+15+18+28+34+35）",
        row: "36",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: false,
        isEdit2: true,
        isEdit3: true,
    },
    {
        name: "全民所有制改制资产评估增值政策资产",
        row: "附列资料",
        originalValue: "",
        indent: 0,
        thisYearDepreciate: "",
        accountRecordTotalDepreciate: "",
        assetsTaxBase: "",
        taxDepreciate: "",
        provisionCalculateDepreciate: "",
        accelerateDepreciateStatistics: "",
        taxTotalDepreciate: "",
        taxAdjustmentAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        iscol: true,
        row2: true,
    },
]


let AnnualEIT105080 = list
export default AnnualEIT105080
